import { trim } from 'lodash';

import config from '../config/Config';

/* eslint-disable no-console */
export const consoleVersions = ({ versionFE, versionBE }: Record<string, string>) => {
  console.log(`FE: ${config.fe_build_number || versionFE};`);
  console.log(`BE: ${trim(versionBE)};`);
  console.log(`JENKINS FE: ${config.jenkins_fe_build_number};`);
  console.log(`JENKINS BE: ${config.jenkins_be_build_number};`);
};
/* eslint-enable */
